export default __webpack_public_path__ + "static/media/audience-network-rewarded-videos.90fe86d4.jpg";